module.exports = __webpack_public_path__ + "__static/site-1768578553954/img/products-carousel-kids.2ac5e020.png";